export const filterRarity = {
  title: "稀有度",
  options: ["1★", "2★", "3★", "4★", "5★", "6★"],
};
export const rarityMap: Record<string, string> = {
  "0": "1★",
  "1": "2★",
  "2": "3★",
  "3": "4★",
  "4": "5★",
  "5": "6★",
};
